import inputStyles from '@/styles/atoms/Input/styles.module.css'

export const EMAIL_REGEX = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

function EmailInput(props) {
  return <input className={inputStyles.ecInput} type="text" {...props} />
}

EmailInput.validate = {
  required: (value) => EMAIL_REGEX.test(value)
}
export default EmailInput
